import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Services() {
  const [activePopup, setActivePopup] = useState<string | null>(null);

  const culturalEvents = [
    {
      id: 'festival-afroverso',
      title: "Festival Afroverso",
      description:
        "Festival annuel célébrant la créativité africaine contemporaine avec mode, musique et art.",
      image:
        "https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/dj.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL2RqLmpwZyIsImlhdCI6MTc2MjUyMzQ5OSwiZXhwIjoxNzk0MDU5NDk5fQ.o_9-iczFaNrJuX1g8W6-qBHhD8QYCLy4xXZfY0qYelI",
      detailedDescription: "Le Festival Afroverso est un événement culturel majeur qui célèbre la richesse et la diversité de la créativité africaine contemporaine. Pendant plusieurs jours, le festival propose une programmation riche mêlant concerts live d'artistes africains émergents et confirmés, défilés de mode mettant en avant les créateurs du continent, expositions d'art contemporain, showcases d'innovations technologiques, et marchés de créateurs. L'événement vise à créer des ponts entre les cultures, à promouvoir les talents africains et à sensibiliser le public à la richesse culturelle du continent. Chaque édition accueille plus de 10 000 visiteurs et rassemble plus de 100 artistes, créateurs et entrepreneurs africains."
    },
    {
      id: 'foires-internationales',
      title: "Pavillon Afrique",
      description:
        "Nos foires internationales sont des marchés thématiques soigneusement organisés qui mettent en lumière l'excellence de l'artisanat africain.",
      image:
        "https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Achats%201.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL0FjaGF0cyAxLmpwZyIsImlhdCI6MTc2MjUyMzIyMywiZXhwIjoxNzk0MDU5MjIzfQ.74b_d04w0lJvwBpK5d0iniy5MTvNBl6IfcDvSz44Vp4",
      detailedDescription: "Nos foires internationales sont des marchés thématiques soigneusement organisés qui mettent en lumière l'excellence de l'artisanat africain, la richesse de la gastronomie du continent et le talent des créateurs contemporains. Ces événements offrent une vitrine exceptionnelle aux entrepreneurs africains pour présenter leurs produits authentiques : textiles traditionnels et modernes, objets d'art, bijoux, cosmétiques naturels, épices et produits alimentaires, instruments de musique, et bien plus encore. Chaque foire est conçue comme une expérience immersive où les visiteurs peuvent découvrir, déguster, acheter et échanger directement avec les créateurs. Nous organisons également des démonstrations d'artisanat, des ateliers culinaires et des rencontres avec les entrepreneurs pour créer des liens authentiques entre les cultures."
    },
    {
      id: 'popup-store',
      title: "Pop-up Store Culturel",
      description:
        "Espaces éphémères dédiés aux marques et créateurs africains dans des lieux emblématiques.",
      image:
        "https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/SAM.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL1NBTS5qcGciLCJpYXQiOjE3NjI1MjM3MDMsImV4cCI6MTc5NDA1OTcwM30.LoUNJfgtTeGVSoHqGb5kKtEbSD6QuLm4TF99al5dHhU",
      detailedDescription: "Nos pop-up stores culturels sont des espaces éphémères stratégiquement implantés dans des lieux emblématiques et à forte fréquentation pour maximiser la visibilité des marques et créateurs africains. Ces boutiques temporaires, d'une durée de quelques jours à plusieurs semaines, sont conçues comme de véritables expériences culturelles immersives. Nous sélectionnons des emplacements premium : centres commerciaux, galeries d'art, espaces culturels, halls d'hôtels, ou événements majeurs. Chaque pop-up store est scénographié pour raconter une histoire, créer une ambiance authentique et mettre en valeur les produits dans un environnement esthétique et professionnel. Nous accompagnons les créateurs dans la formation à la vente, la gestion des stocks, et la communication digitale pour optimiser les retombées commerciales."
    },
    {
      id: 'afrovidedressing',
      title: "Afrovidedressing",
      description:
        "Événements de mode circulaire célébrant le style africain et la consommation responsable.",
      image:
        "https://public.readdy.ai/ai/img_res/f5cf8b0f9957378687004387ef8ca47d.jpg",
      detailedDescription: "L'Afrovidedressing est un concept innovant de marché de la mode africaine responsable et circulaire qui révolutionne la consommation de vêtements africains. Ces événements permettent de donner une seconde vie aux vêtements traditionnels et contemporains africains tout en promouvant une consommation éthique et durable. Chaque Afrovidedressing rassemble des particuliers, des créateurs et des boutiques qui proposent des pièces authentiques : boubous, dashikis, pagnes, robes modernes inspirées des traditions, accessoires et bijoux africains. L'événement inclut également des ateliers de customisation, des conseils en styling afro, des rencontres avec des créateurs engagés dans la mode durable, et des sensibilisations aux enjeux environnementaux de l'industrie textile. C'est un lieu de partage, d'échange et de célébration du style africain accessible à tous."
    },
  ];

  const institutionalEvents = [
    {
      id: 'conferences-afrobusiness',
      title: "Conférences Afro-business",
      description:
        "Rencontres professionnelles sur l'entrepreneuriat et l'innovation en Afrique.",
      image:
        "https://readdy.ai/api/search-image?query=professional%20african%20business%20conference%2C%20modern%20conference%20room%2C%20african%20business%20leaders%20speaking%2C%20elegant%20corporate%20event%20setup%2C%20professional%20networking%20atmosphere%2C%20contemporary%20business%20environment&width=400&height=300&seq=conference-example&orientation=landscape",
      detailedDescription: "Nos conférences Afro-business sont des événements professionnels de haut niveau qui rassemblent entrepreneurs, investisseurs, décideurs politiques et experts pour explorer les opportunités d'affaires et d'innovation en Afrique. Ces rencontres abordent des thématiques stratégiques : transformation digitale, fintech, agritech, énergies renouvelables, économie créative, et coopération franco-africaine. Chaque conférence propose des keynotes inspirantes, des tables rondes thématiques, des sessions de networking structurées, et des présentations de startups innovantes. Nous invitons des speakers de renommée internationale, des success stories d'entrepreneurs africains, et facilitons les rencontres B2B. L'objectif est de créer des synergies concrètes, de favoriser les investissements et de promouvoir une image moderne et dynamique de l'Afrique économique."
    },
    {
      id: 'inaugurations-culturelles',
      title: "Inaugurations Culturelles",
      description:
        "Cérémonies d'ouverture d'espaces culturels et d'expositions africaines.",
      image:
        "https://readdy.ai/api/search-image?query=elegant%20cultural%20center%20inauguration%20with%20african%20art%20displays%2C%20official%20ceremony%2C%20cultural%20dignitaries%2C%20modern%20exhibition%20space%2C%20professional%20event%20photography%2C%20warm%20ceremonial%20lighting&width=400&height=300&seq=inauguration-example&orientation=landscape",
      detailedDescription: "Nous organisons des inaugurations culturelles d'exception pour marquer l'ouverture d'espaces dédiés à la culture africaine : centres culturels, galeries d'art, expositions temporaires, ou installations permanentes. Ces cérémonies officielles respectent les codes protocolaires tout en célébrant la richesse culturelle africaine. Nous coordonnons la présence de personnalités officielles, d'ambassadeurs, de mécènes et de figures emblématiques de la culture africaine. Chaque inauguration inclut des performances artistiques (musique, danse, poésie), des visites guidées exclusives, des cocktails avec produits africains authentiques, et une couverture médiatique professionnelle. Nous veillons à créer un moment solennel et festif qui honore l'art africain tout en respectant l'importance institutionnelle de l'événement."
    },
    {
      id: 'soirees-partenaires',
      title: "Soirées Partenaires",
      description:
        "Événements de networking dédiés aux acteurs de la coopération franco-africaine.",
      image:
        "https://readdy.ai/api/search-image?query=elegant%20business%20networking%20event%20with%20african%20and%20french%20professionals%2C%20sophisticated%20venue%2C%20cultural%20partnership%20celebration%2C%20professional%20cocktail%20atmosphere%2C%20warm%20ambient%20lighting&width=400&height=300&seq=partners-example&orientation=landscape",
      detailedDescription: "Nos soirées partenaires sont des événements de networking haut de gamme qui rassemblent les acteurs clés de la coopération franco-africaine : diplomates, chefs d'entreprise, responsables d'ONG, investisseurs, et leaders d'opinion. Ces soirées se déroulent dans des lieux prestigieux et offrent un cadre privilégié pour développer des partenariats stratégiques. La programmation inclut des cocktails dînatoires avec une gastronomie fusion franco-africaine, des présentations courtes de projets innovants, des espaces de networking thématiques, et des animations culturelles raffinées. Nous facilitons les rencontres ciblées grâce à un système de mise en relation personnalisé et organisons des sessions de speed-networking sectorielles. L'objectif est de créer des opportunités de collaboration concrètes entre la France et l'Afrique dans tous les domaines : économie, culture, éducation, et développement durable."
    },
    {
      id: 'actions-sensibilisation',
      title: "Actions de Sensibilisation",
      description:
        "Campagnes éducatives sur les enjeux africains contemporains et la diversité culturelle.",
      image:
        "https://readdy.ai/api/search-image?query=educational%20awareness%20campaign%20about%20african%20culture%2C%20diverse%20audience%20learning%2C%20interactive%20cultural%20presentation%2C%20community%20engagement%2C%20educational%20workshop%20atmosphere%2C%20inclusive%20environment&width=400&height=300&seq=awareness-example&orientation=landscape",
      detailedDescription: "Nos actions de sensibilisation sont des campagnes éducatives innovantes conçues pour déconstruire les stéréotypes et promouvoir une image authentique et moderne de l'Afrique. Ces initiatives s'adressent à différents publics : étudiants, professionnels, grand public, et décideurs. Nous organisons des conférences-débats dans les universités, des ateliers interactifs dans les entreprises, des expositions itinérantes, et des campagnes digitales engageantes. Chaque action combine témoignages d'experts africains, données factuelles sur le développement du continent, présentations d'innovations africaines, et échanges interculturels. Nous utilisons des formats variés : documentaires, jeux éducatifs, réalité virtuelle, et expériences immersives pour maximiser l'impact pédagogique. L'objectif est de favoriser une meilleure compréhension des enjeux africains contemporains et de promouvoir la diversité culturelle comme richesse collective."
    },
  ];

  const immersiveExperiences = [
    {
      id: 'ateliers-participatifs',
      title: "Ateliers Participatifs",
      description:
        "Workshops créatifs autour de l'artisanat, la cuisine et les traditions africaines.",
      image:
        "https://readdy.ai/api/search-image?query=hands-on%20african%20cultural%20workshop%20with%20participants%20learning%20traditional%20crafts%2C%20interactive%20cultural%20experience%2C%20collaborative%20learning%20environment%2C%20diverse%20participants%20engaged%20in%20creative%20activities&width=400&height=300&seq=workshop-example&orientation=landscape",
      detailedDescription: "Nos ateliers participatifs sont des expériences immersives qui permettent aux participants de découvrir et pratiquer les arts traditionnels africains. Ces workshops couvrent une large gamme d'activités : tissage de pagnes, poterie traditionnelle, fabrication de bijoux, cuisine africaine authentique, apprentissage de rythmes percussifs, initiation aux danses traditionnelles, et création d'objets décoratifs. Chaque atelier est animé par des artisans experts qui transmettent leurs savoir-faire ancestraux tout en expliquant la signification culturelle de chaque technique. Les participants repartent avec leurs créations et une compréhension approfondie des traditions africaines. Nous adaptons les ateliers à tous les âges et niveaux, des enfants aux adultes, en passant par les team-buildings d'entreprise. Ces expériences favorisent l'échange interculturel et la valorisation des patrimoines africains."
    },
    {
      id: 'defiles-afromode',
      title: "Défilés Afro-mode",
      description:
        "Présentations de mode célébrant la créativité des designers africains contemporains.",
      image:
        "https://readdy.ai/api/search-image?query=african%20fashion%20show%20with%20models%20wearing%20contemporary%20african%20designs%2C%20runway%20presentation%2C%20creative%20african%20fashion%20designers%2C%20cultural%20fashion%20celebration%2C%20professional%20fashion%20event&width=400&height=300&seq=fashion-show-example&orientation=landscape",
      detailedDescription: "Nos défilés Afro-mode sont des événements fashion de prestige qui mettent en lumière la créativité exceptionnelle des designers africains contemporains. Ces shows présentent des collections qui allient traditions ancestrales et modernité, créant un dialogue unique entre héritage culturel et innovation stylistique. Chaque défilé raconte une histoire à travers les créations : utilisation de textiles traditionnels revisités, techniques artisanales sublimées, et silhouettes contemporaines inspirées des codes africains. Nous collaborons avec des créateurs émergents et confirmés du continent et de la diaspora, offrant une plateforme de visibilité internationale. Les défilés incluent une scénographie soignée, un casting de mannequins diversifié, une bande sonore mêlant musiques africaines traditionnelles et contemporaines, et une couverture médiatique professionnelle. Ces événements contribuent à repositionner la mode africaine comme force créative majeure sur la scène internationale."
    },
    {
      id: 'afterworks-culturels',
      title: "Afterworks Culturels",
      description:
        "Rencontres professionnelles décontractées autour de la culture africaine.",
      image:
        "https://readdy.ai/api/search-image?query=relaxed%20professional%20afterwork%20event%20with%20african%20cultural%20theme%2C%20networking%20atmosphere%2C%20contemporary%20venue%2C%20diverse%20professionals%20socializing%2C%20warm%20evening%20lighting%2C%20cultural%20celebration&width=400&height=300&seq=afterwork-example&orientation=landscape",
      detailedDescription: "Nos afterworks culturels sont des événements de networking décontractés qui allient développement professionnel et découverte culturelle africaine. Ces rencontres en fin de journée offrent un cadre convivial pour échanger entre professionnels tout en s'immergeant dans la richesse culturelle africaine. Chaque afterwork propose une programmation variée : dégustation de cocktails et mets africains, mini-concerts d'artistes émergents, expositions d'art contemporain, présentations courtes de projets innovants, et espaces de networking thématiques. Nous invitons des entrepreneurs africains inspirants, des artistes talentueux, et des experts sectoriels pour partager leurs expériences. L'ambiance décontractée favorise les échanges authentiques et la création de synergies professionnelles. Ces événements s'adressent aux cadres, entrepreneurs, créatifs, et tous les professionnels intéressés par les opportunités africaines et la diversité culturelle."
    },
    {
      id: 'rencontres-thematiques',
      title: "Rencontres Thématiques",
      description:
        "Tables rondes et débats sur les enjeux contemporains de l'Afrique.",
      image:
        "https://readdy.ai/api/search-image?query=intimate%20roundtable%20discussion%20about%20african%20contemporary%20issues%2C%20diverse%20panel%20speakers%2C%20engaged%20audience%2C%20modern%20conference%20setting%2C%20intellectual%20exchange%20atmosphere&width=400&height=300&seq=roundtable-example&orientation=landscape",
      detailedDescription: "Nos rencontres thématiques sont des forums d'échange intellectuel qui explorent en profondeur les enjeux contemporains de l'Afrique. Ces événements rassemblent experts, chercheurs, praticiens et citoyens engagés autour de sujets d'actualité : développement durable, innovations technologiques, entrepreneuriat social, arts et culture, éducation, santé, et gouvernance. Chaque rencontre adopte un format interactif mêlant conférences, tables rondes, ateliers de réflexion, et sessions de questions-réponses. Nous invitons des intervenants de haut niveau : universitaires, entrepreneurs sociaux, artistes engagés, et leaders d'opinion africains. L'objectif est de dépasser les idées reçues, d'apporter des éclairages nuancés sur les réalités africaines, et de favoriser une compréhension approfondie des transformations en cours sur le continent. Ces rencontres contribuent à nourrir le débat public et à promouvoir une vision éclairée de l'Afrique contemporaine."
    },
  ];

  const closePopup = () => {
    setActivePopup(null);
  };

  const openPopup = (eventId: string) => {
    setActivePopup(eventId);
  };

  const getEventDetails = (eventId: string) => {
    const allEvents = [...culturalEvents, ...institutionalEvents, ...immersiveExperiences];
    return allEvents.find(event => event.id === eventId);
  };

  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=professional%20event%20planning%20team%20organizing%20african%20cultural%20celebration%2C%20diverse%20team%20working%20together%2C%20modern%20event%20space%20preparation%2C%20cultural%20event%20setup%2C%20professional%20event%20management%2C%20warm%20collaborative%20atmosphere&width=1920&height=600&seq=services-hero&orientation=landscape')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Nos prestations</h1>
          <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
            Découvrez nos trois grands formats d'intervention pour créer des événements uniques,
            inclusifs et valorisant la diversité culturelle africaine
          </p>
        </div>
      </section>

      {/* Navigation des prestations */}
      <section className="py-12 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8">
            <a
              href="#culturels"
              className="flex items-center px-6 py-3 bg-orange-100 text-orange-700 rounded-full hover:bg-orange-200 transition-colors"
            >
              <i className="ri-music-2-line mr-2"></i>
              Événements culturels
            </a>
            <a
              href="#institutionnels"
              className="flex items-center px-6 py-3 bg-amber-100 text-amber-700 rounded-full hover:bg-amber-200 transition-colors"
            >
              <i className="ri-building-line mr-2"></i>
              Événements institutionnels
            </a>
            <a
              href="#immersifs"
              className="flex items-center px-6 py-3 bg-orange-100 text-orange-700 rounded-full hover:bg-orange-200 transition-colors"
            >
              <i className="ri-hand-heart-line mr-2"></i>
              Expériences immersives
            </a>
          </div>
        </div>
      </section>

      {/* 1. Événements culturels et grand public */}
      <section id="culturels" className="py-20 bg-gradient-to-b from-orange-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mx-auto mb-6">
              <i className="ri-music-2-line text-3xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Événements culturels et grand public
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Festivals, marchés, pop-up stores, videdressings et expositions qui célèbrent
              la richesse culturelle africaine contemporaine et touchent un large public
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {culturalEvents.map((event, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300"
              >
                <div
                  className="h-64 bg-cover bg-center"
                  style={{ 
                    backgroundImage: event.title === "Afrovidedressing" 
                      ? `url('https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/vue%20afroviderssing.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL3Z1ZSBhZnJvdmlkZXJzc2luZy5qcGciLCJpYXQiOjE3NjI1MjI5MjcsImV4cCI6MTc5NDA1ODkyN30.JPuVsWg6jpvNRllis8NnFMguXqh6jGdN7ohnpRAG4iQ')`
                      : `url('${event.image}')`
                  }}
                ></div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{event.title}</h3>
                  <p className="text-gray-600 mb-6">{event.description}</p>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => openPopup(event.id)}
                  >
                    <i className="ri-information-line mr-2"></i>
                    En savoir plus
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Nos services pour les événements culturels</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Conception et planification */}
              <div className="flex items-start space-x-3">
                <i className="ri-calendar-event-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Conception et planification</h4>
                  <p className="text-gray-600 text-sm">Développement du concept, programmation artistique</p>
                </div>
              </div>

              {/* Recherche de lieux */}
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Recherche de lieux</h4>
                  <p className="text-gray-600 text-sm">Sélection d'espaces adaptés à votre événement</p>
                </div>
              </div>

              {/* Coordination artistique (fixed markup) */}
              <div className="flex items-start space-x-3">
                <i className="ri-team-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Coordination artistique</h4>
                  <p className="text-gray-600 text-sm">Gestion des artistes et intervenants culturels</p>
                </div>
              </div>

              {/* Communication */}
              <div className="flex items-start space-x-3">
                <i className="ri-megaphone-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Communication</h4>
                  <p className="text-gray-600 text-sm">Stratégie de promotion et relations presse</p>
                </div>
              </div>

              {/* Production technique */}
              <div className="flex items-start space-x-3">
                <i className="ri-settings-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Production technique</h4>
                  <p className="text-gray-600 text-sm">Son, éclairage, scénographie</p>
                </div>
              </div>

              {/* Gestion logistique */}
              <div className="flex items-start space-x-3">
                <i className="ri-shield-check-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Gestion logistique</h4>
                  <p className="text-gray-600 text-sm">Sécurité, accueil, restauration</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Événements institutionnels */}
      <section id="institutionnels" className="py-20 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-amber-500 to-orange-500 rounded-full mx-auto mb-6">
              <i className="ri-building-line text-3xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Événements institutionnels
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Conférences, inaugurations, soirées partenaires et actions de sensibilisation
              pour valoriser les enjeux africains auprès des décideurs et institutions
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {institutionalEvents.map((event, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300"
              >
                <div
                  className="h-64 bg-cover bg-center"
                  style={{ backgroundImage: `url('${event.image}')` }}
                ></div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{event.title}</h3>
                  <p className="text-gray-600 mb-6">{event.description}</p>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => openPopup(event.id)}
                  >
                    <i className="ri-information-line mr-2"></i>
                    En savoir plus
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Nos services pour les événements institutionnels</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="flex items-start space-x-3">
                <i className="ri-presentation-line text-amber-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Conception de programmes</h4>
                  <p className="text-gray-600 text-sm">Développement de contenus et formats adaptés</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-user-star-line text-amber-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Recherche d'intervenants</h4>
                  <p className="text-gray-600 text-sm">Identification et coordination d'experts</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-building-2-line text-amber-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Gestion protocolaire</h4>
                  <p className="text-gray-600 text-sm">Respect des codes institutionnels</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-live-line text-amber-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Captation et diffusion</h4>
                  <p className="text-gray-600 text-sm">Enregistrement et streaming en direct</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-file-text-line text-amber-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Documentation</h4>
                  <p className="text-gray-600 text-sm">Comptes-rendus et supports de communication</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-global-line text-amber-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Relations internationales</h4>
                  <p className="text-gray-600 text-sm">Coordination avec partenaires africains</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. Expériences immersives */}
      <section id="immersifs" className="py-20 bg-gradient-to-b from-orange-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mx-auto mb-6">
              <i className="ri-hand-heart-line text-3xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Expériences immersives
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Ateliers participatifs, défilés, afterworks et rencontres thématiques
              pour vivre la culture africaine de l'intérieur et créer des liens authentiques
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {immersiveExperiences.map((event, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300"
              >
                <div
                  className="h-64 bg-cover bg-center"
                  style={{ backgroundImage: `url('${event.image}')` }}
                ></div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{event.title}</h3>
                  <p className="text-gray-600 mb-6">{event.description}</p>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => openPopup(event.id)}
                  >
                    <i className="ri-information-line mr-2"></i>
                    En savoir plus
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Nos services pour les expériences immersives</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="flex items-start space-x-3">
                <i className="ri-palette-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Conception créative</h4>
                  <p className="text-gray-600 text-sm">Développement d'expériences sur-mesure</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-graduation-cap-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Formation d'animateurs</h4>
                  <p className="text-gray-600 text-sm">Préparation d'intervenants spécialisés</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-tools-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Fourniture de matériel</h4>
                  <p className="text-gray-600 text-sm">Équipements et matières premières</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-group-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Animation participative</h4>
                  <p className="text-gray-600 text-sm">Facilitation d'ateliers interactifs</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-camera-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Captation créative</h4>
                  <p className="text-gray-600 text-sm">Documentation photo et vidéo artistique</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-gift-line text-orange-500 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Création de souvenirs</h4>
                  <p className="text-gray-600 text-sm">Objets personnalisés et créations uniques</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pop-up Modal */}
      {activePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <h2 className="text-3xl font-bold text-gray-900 pr-8">
                  {getEventDetails(activePopup)?.title}
                </h2>
                <button 
                  onClick={closePopup}
                  className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              
              <div className="mb-6">
                <img 
                  src={getEventDetails(activePopup)?.image} 
                  alt={getEventDetails(activePopup)?.title}
                  className="w-full h-64 object-cover rounded-xl"
                />
              </div>
              
              <div className="prose prose-lg max-w-none">
                <p className="text-gray-700 leading-relaxed text-lg">
                  {getEventDetails(activePopup)?.detailedDescription}
                </p>
              </div>
              
              <div className="mt-8 flex justify-center">
                <Button onClick={closePopup}>
                  <i className="ri-check-line mr-2"></i>
                  Compris
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Prochains événements */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Prochains événements
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Découvrez nos événements à venir et rejoignez-nous pour célébrer la culture africaine
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Pavillon Afrique */}
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mb-6">
                <i className="ri-store-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Pavillon Afrique</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-center space-x-3">
                  <i className="ri-calendar-line text-orange-600"></i>
                  <span className="text-gray-700 font-semibold">2 au 6 Avril 2026</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-map-pin-line text-orange-600"></i>
                  <span className="text-gray-700">Foire Internationale de Nantes</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-time-line text-orange-600"></i>
                  <span className="text-gray-700">18h30</span>
                </div>
              </div>
              <p className="text-gray-600 mb-6">
                Une vitrine exceptionnelle de la culture africaine au cœur de la Foire Internationale de Nantes.
              </p>
              <Button variant="outline" size="sm" href="/projects">
                <i className="ri-information-line mr-2"></i>
                En savoir plus
              </Button>
            </div>

            {/* Afrovidedressing */}
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mb-6">
                <i className="ri-recycle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Afrovidedressing</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-center space-x-3">
                  <i className="ri-calendar-line text-orange-600"></i>
                  <span className="text-gray-700 font-semibold">Mai 2026</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-shirt-line text-orange-600"></i>
                  <span className="text-gray-700">Mode circulaire africaine</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-leaf-line text-orange-600"></i>
                  <span className="text-gray-700">Consommation responsable</span>
                </div>
              </div>
              <p className="text-gray-600 mb-6">
                Marché de la mode africaine responsable et circulaire qui promeut la consommation éthique.
              </p>
              <Button variant="outline" size="sm" href="/projects">
                <i className="ri-information-line mr-2"></i>
                En savoir plus
              </Button>
            </div>

            {/* Afroverso */}
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mb-6">
                <i className="ri-music-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Festival Afroverso</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-center space-x-3">
                  <i className="ri-calendar-line text-orange-600"></i>
                  <span className="text-gray-700 font-semibold">Juillet 2026</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-palette-line text-orange-600"></i>
                  <span className="text-gray-700">Art & Créativité</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-music-line text-orange-600"></i>
                  <span className="text-gray-700">Musique & Culture</span>
                </div>
              </div>
              <p className="text-gray-600 mb-6">
                Festival célébrant la créativité africaine à travers la mode, la musique, l'art et l'innovation.
              </p>
              <Button variant="outline" size="sm" href="/projects">
                <i className="ri-information-line mr-2"></i>
                En savoir plus
              </Button>
            </div>
          </div>

          <div className="text-center mt-12">
            <Button size="lg" href="/contact">
              <i className="ri-calendar-event-line mr-2"></i>
              Participer à nos événements
            </Button>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-orange-500 to-amber-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Prêt à créer votre événement sur-mesure ?
          </h2>
          <p className="text-xl text-orange-100 mb-8">
            Contactez-nous pour discuter de votre projet et découvrir comment nos prestations
            peuvent donner vie à vos ambitions culturelles
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="secondary" size="lg">
              <i className="ri-phone-line mr-2"></i>
              Demander un devis
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="border-white text-white hover:bg-white hover:text-orange-500"
            >
              <i className="ri-calendar-line mr-2"></i>
              Planifier un rendez-vous
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
